import { render, staticRenderFns } from "./ScanAssistant.vue?vue&type=template&id=480dda21&scoped=true"
import script from "./ScanAssistant.vue?vue&type=script&lang=js"
export * from "./ScanAssistant.vue?vue&type=script&lang=js"
import style0 from "./ScanAssistant.vue?vue&type=style&index=0&id=480dda21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480dda21",
  null
  
)

export default component.exports